import Qs from 'querystring';

export const getActiveBooking = (bookingId = null, loading = true) => dispatch => {
  if (loading) {
    dispatch({
      type: 'SET_CABIN_BOOKING_LOADING',
      loading: true
    });
  }
  return fetch(`/api/booking/${bookingId || ''}`, {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_CABIN_BOOKING',
          booking: response.data
        });
        return response.data;
      }
      dispatch({
        type: 'UPDATE_CABIN_BOOKING',
        booking: undefined
      });
      dispatch({
        type: 'SET_CABIN_BOOKING_ERROR',
        message: response.message
      });
      return null;
    })
    .catch(ex => console.log('failed fetching user', ex));
};

export const createBooking = (cabinWeekId, currency, extras) => dispatch => {
  dispatch({
    type: 'SET_BOOKING_LOADING',
    loading: true
  });

  const qstr = Qs.stringify({
    currency,
    extras: extras?.join(',')
  });
  return fetch(`/api/booking/start-cabin/${cabinWeekId}?${qstr}`, {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data
        });
        return response.data;
      }
      dispatch({
        type: 'SET_BOOKING_ERROR',
        message: response.message
      });
      return response;

    })
    .catch(ex => console.log('failed fetching user', ex));
};

export const cancelBooking = bookingId => dispatch =>
  fetch(`/api/booking/${bookingId}/cancel`, {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: undefined
        });
      }
    })
    .catch(ex => console.err('failed canceling booking', ex));

export const checkoutBooking = bookingId => dispatch =>
  fetch(`/api/booking/${bookingId}/checkout`, {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_CABIN_BOOKING',
          booking: response.data
        });
        return response.data;
      }
      return null;
    })
    .catch(ex => console.log('failed fetching user', ex));

export const getCrewMembers = bookingId => dispatch =>
  fetch(`/api/booking/${bookingId}/crew-members`, {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'SET_CABIN_CREW',
          crewMembers: response.data.crewMembers,
          hostess: response.data.hostess,
          skipper: response.data.skipper,
          inviteLink: response.data.inviteLink
        });
      }
      return response;
    })
    .catch(error => {
      console.error('failed fetching crew members', error);
      return { status: 'failed', error: { message: error.message } };
    });

export const addUserToCrew = booking => dispatch =>
  fetch(`/api/booking/${booking.id}/add-user-to-crew`, {
    method: 'POST',
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'ADD_CABIN_USER',
          crewMember: response.data
        });
      }
      return response;
    });

export const sendCrewInvitation = (booking, emails) => dispatch => {
  const bookingId = booking.id;
  return fetch(`/api/booking/${bookingId}/send-invites`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      emails
    })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'INVITE_CABIN_EMAILS',
          crewInvites: response.data.crewInvites
        });
      }
      return response;
    });
};

export const deleteCrewMember = member => dispatch => {
  const bookingId = member.cabinBooking.id;
  const memberId = member.id;
  return fetch(`/api/booking/${bookingId}/delete-crew-member`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      crewMemberId: member.id
    })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'DELETE_CABIN_MEMBER',
          memberId
        });
      }
      return response;
    });
};

export const createPayment = (orderId, amount, token, currency, service, cardHolder) => (
  dispatch,
  getState
) =>
  fetch('/api/payment/create', {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      orderId,
      token,
      amount,
      currency,
      service,
      cardHolder
    })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success' && response.data) {
        dispatch({
          type: 'ADD_CABIN_PAYMENT',
          payment: response.data
        });
      }
      // Refresh Booking to get up-to-date version of MainOrder and Invoice:
      const booking = getState().cabinBooking.currentBooking;
      if (booking) {
        getActiveBooking(booking.id, false)(dispatch);
      }
      return response;
    })
    .catch(error => {
      console.error('failed making a payment', error);
      return { status: 'failed', error: { message: error.message } };
    });
